export default {
  set(key, value) {
    let data;
    try {
      data = JSON.parse(window.localStorage.briefWidget || '{}');
    } catch (e) {
      // No ls support or no data stored
    }
    if (data) {
      data[key] = value;
      window.localStorage.briefWidget = JSON.stringify(data);
    }
    return data || {};
  },
  get(key) {
    let data;
    try {
      data = JSON.parse(window.localStorage.briefWidget || '{}');
    } catch (e) {
      // No ls support or no data stored
    }
    if (!data) return undefined;
    return data[key];
  },
  remove(key) {
    let data;
    try {
      data = JSON.parse(window.localStorage.briefWidget || '{}');
    } catch (e) {
      // No ls support or no data stored
    }
    if (data) {
      if (data[key]) {
        data[key] = undefined;
        delete data[key];
      }
      window.localStorage.briefWidget = JSON.stringify(data);
    }
  },
  clear() {
    try {
      window.localStorage.removeItem('briefWidget');
    } catch (e) {
      // No ls support or no data stored
    }
  },
};
